<script>
export default {
    data() {
        return {
            subscriptions: [],
        }
    },
    methods: {
        onSubscriptionUpdate(original, updated) {
            const subscription = this.subscriptions.find(s => s === original);

            if (subscription) {
                Object.keys(updated).forEach((key) => subscription[key] = updated[key]);
            }
        },
        onSubscriptionCreate(subscription) {
            this.subscriptions.push(subscription);
        },
    }
}
</script>
